import Parser from 'html-react-parser'

const config = {}

export const parseHTML = (html) => {
	const clean = Parser(html, config)
	return clean
}

export default parseHTML
